export default function scrollIntoView(
    el: Element,
    { offset = 105, smooth = false }: { offset?: number, smooth?: boolean } = {},
) {
    const rect = el.getBoundingClientRect();
    window.scrollTo({
        top: window.scrollY + rect.top - offset,
        behavior: smooth ? 'smooth' : 'instant',
    });
    // expand FAQ answers
    if (el.classList.contains('questions-box-item-wrapper')) {
        const question = el.querySelector<HTMLDivElement>('.questions-box-item-question-wrapper');
        const answer = el.querySelector<HTMLDivElement>('.questions-box-item-answer-wrapper');
        if (question !== null && answer !== null && !answer.classList.contains('questions-box-item-answer-wrapper-expand')) {
            question.click();
        }
    }
}
